import { FlexBetween } from "components/flex-box";
import { H4 } from "components/Typography";
import Button from "@mui/material/Button";
import { formatCurrency } from "common";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import { CameraAlt } from "@mui/icons-material";

import { useAppSelector } from "hooks/use-app-selector";
import { useCart } from "hooks/use-cart";
import { useIsMobile } from "hooks";
import { useRouter } from "next/router";
import modules from "modules";
import { useLoginStatus } from "hooks/useLoginStatus";
import { DialugoeDecision } from "components/dialog/DialogueDecision";
import { FC, useState } from "react";
import { useDialogueShow } from "hooks/useDialogue";
import { Container, Grid } from "@mui/material";
import { userBuildFlag } from "common/constants/feature-toggles";
import { navigationRoutes } from "common/constants/navigation-routes";

const { selectors: pcBuilderSelectors } = modules.pcBuilder;

type Props = {
  isBuildIncomplete?: boolean;
  saveString?: string;
  openUploadDialog?: () => void;
  onScreenShot?: () => void;
};

const BuilderToolbar: FC<Props> = ({
  isBuildIncomplete,
  saveString,
  openUploadDialog,
  onScreenShot,
}) => {
  const { push, replace } = useRouter();
  const isMobile = useIsMobile();
  const { addBuildPartsToCart } = useCart();
  const { isUserLogin } = useLoginStatus();
  const { showLoginFormOpen } = useDialogueShow();
  const isLogin = isUserLogin;

  const [isDecision, setDecision] = useState<boolean>(false);

  const totalAmount = useAppSelector(
    pcBuilderSelectors.selectBuildPartsTotalAmount
  );

  const onClickAddToCart = () => {
    if (isLogin) {
      //clear cart first before adding item
      addBuildPartsToCart(navigationRoutes.userCart);
      setDecision(!isDecision);
    }
  };

  const toggleDecision = () => {
    setDecision(!isDecision);
  };

  const SubTotal = () => (
    <FlexBetween alignItems="center" mb={1}>
      <H4 fontWeight={600}>{"SUBTOTAL"}</H4>
      <H4 fontWeight={600}>{formatCurrency(totalAmount)}</H4>
    </FlexBetween>
  );

  const AddToCart = () => (
    <>
      {totalAmount ? (
        <Button
          disabled={!totalAmount}
          color="secondary"
          variant="contained"
          style={{ borderRadius: 4 }}
          sx={{
            height: 30,
            paddingLeft: 4,
            paddingRight: 4,
            bgcolor: "#CF151A",
          }}
          onClick={isLogin ? toggleDecision : showLoginFormOpen}
        >
          ADD TO CART
        </Button>
      ) : null}
    </>
  );

  return !isMobile ? (
    <Container>
      <SubTotal />
      <Grid
        direction="column"
        columns={12}
        bgcolor="white"
        padding={1}
        sx={{ borderRadius: 2 }}
      >
        <Grid item container md={12} display={"flex"} marginBottom={1}>
          <Button
            variant="text"
            color="secondary"
            startIcon={<CameraAlt />}
            onClick={onScreenShot}
          >
            Take a Screenshot
          </Button>
        </Grid>
        <Grid item container md={12} display={"flex"} marginBottom={1}>
          {userBuildFlag ? (
            <Button
              variant="text"
              color="secondary"
              disabled={isBuildIncomplete}
              startIcon={<BookmarkBorderIcon />}
              onClick={openUploadDialog}
            >
              {saveString}
            </Button>
          ) : null}
        </Grid>
        <Grid
          item
          container
          md={12}
          display={"flex"}
          justifyContent={"center"}
          marginBottom={1}
        >
          <AddToCart />
        </Grid>
      </Grid>
      <DialugoeDecision
        toggleOpen={isDecision}
        dialogueTitle={"DIY Builder"}
        dialogueContent={
          "Adding DIY components to cart requires to remove all current item(s) on your cart, Are you sure you want to add DIY components in your cart?"
        }
        buttonTitle={"Proceed"}
        toggleOpenClose={toggleDecision}
        setFunction={onClickAddToCart}
      />
    </Container>
  ) : null;
};

export default BuilderToolbar;
